const GOOGLE_FONTS_API = 'https://fonts.googleapis.com/css2';
const loadedFonts = new Set<string>();

const SYSTEM_FONTS = [
  'system-ui',
  '-apple-system',
  'blinkmacsystemfont',
  'segoe ui',
  'sans-serif',
  'serif',
  'monospace',
  'roboto', // Often pre-installed on Android
];

/**
 * Extract the primary font name from a CSS font stack.
 * "Roboto, sans-serif" -> "Roboto"
 * "system-ui, -apple-system, sans-serif" -> "system-ui"
 */
function extractFontName(fontStack: string): string {
  return fontStack.split(',')[0].trim().replace(/['"]/g, '');
}

/**
 * Check if a font is a system font that doesn't need to be loaded.
 */
function isSystemFont(fontName: string): boolean {
  return SYSTEM_FONTS.some(
    (sysFont) => fontName.toLowerCase() === sysFont.toLowerCase()
  );
}

/**
 * Load a Google Font into the document head.
 * Fonts are loaded with weights 400, 500, 600, 700.
 */
export function loadGoogleFont(fontStack: string): void {
  const fontName = extractFontName(fontStack);

  // Skip system fonts
  if (isSystemFont(fontName)) {
    return;
  }

  // Skip already loaded fonts
  if (loadedFonts.has(fontName)) {
    return;
  }

  try {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${GOOGLE_FONTS_API}?family=${encodeURIComponent(fontName)}:wght@400;500;600;700&display=swap`;
    document.head.appendChild(link);

    loadedFonts.add(fontName);
  } catch {
    // Silent failure - font won't load but widget will continue working
  }
}
